import { TintingIntensity } from '@order/steps/types'
import React from 'react'
import { Defs, LinearGradient, Path, Stop, Svg } from 'react-native-svg'
import { defaultBackColors } from './styles'
import { IconProps } from '@tabler/icons-react-native'
import { getGradientBreakpoint, linearGradientProps } from '../utils'
import { ColorConfig, opacityToDecimal } from '@ca/common/types'
import { Intensity } from '@ca/common'

export interface AttributeIntensityProps extends IconProps {
  colorConfig: ColorConfig
  intensity?: TintingIntensity
}

const d =
  'M0 12C0 5.37258 5.37258 0 12 0H52C58.6274 0 64 5.37258 64 12V52C64 58.6274 58.6274 64 52 64H12C5.37258 64 0 58.6274 0 52V12Z'

export default function AttributeIntensity({
  colorConfig,
  intensity = 'full',
  size = 24,
  ...props
}: AttributeIntensityProps) {
  const front = colorConfig.front
  const back =
    colorConfig.back && colorConfig.back.length > 0
      ? colorConfig.back
      : defaultBackColors
  const opacities = Intensity.utils.getIntensityOpacity(intensity)

  return (
    <Svg width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
      <Path d={d} fill="white" />
      <Path d={d} fill="url(#tinting-intensity-back)" />
      <Path d={d} fill="url(#tinting-intensity-front)" />
      <Defs>
        <LinearGradient id="tinting-intensity-back" {...linearGradientProps}>
          {back.map((color, index) => (
            <Stop
              key={index}
              offset={getGradientBreakpoint(index, back.length)}
              stopColor={color.color}
              stopOpacity={
                opacityToDecimal(color.opacity) *
                opacities[index % opacities.length]
              }
            />
          ))}
        </LinearGradient>
        <LinearGradient id="tinting-intensity-front" {...linearGradientProps}>
          {front.map((color, index) => (
            <Stop
              key={index}
              offset={getGradientBreakpoint(index, front.length)}
              stopColor={color.color}
              stopOpacity={
                opacityToDecimal(color.opacity) *
                opacities[index % opacities.length]
              }
            />
          ))}
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
